export default "__VITE_ASSET__pTexn$XR__"